import { QuoteProductLine } from "../models/quoting/QuoteProductLine";
import { apiPost } from "./api-post";
import { StartQuoteRequest } from "../models/quoting/StartQuoteRequest";

export function goToQuote(productLines?: Array<QuoteProductLine>, agentCode?: string, referralCode?: string, agentId?: string, subProducerAgentId?: string, utmCampaign?: string) {
    const payload = new StartQuoteRequest(productLines, agentId !== undefined ? agentId : agentCode, subProducerAgentId, utmCampaign);
    apiPost<StartQuoteRequest, string>('/api/StartQuote', payload)
        .then(uri => {
            const url = new URL(uri);
            if (referralCode) {
                url.searchParams.append('referralCode', referralCode);
            } else {
                console.log('No referral code found');
            }

            // Handling 'utm_campaign'
            const campaignCode = utmCampaign || 'dlsm';
            if (window.location.href.includes('/drive-less-save-more') || utmCampaign) {
                // Append 'utm_campaign' based on the condition
                url.searchParams.append('utm_campaign', campaignCode);
            }

            window.location.href = url.href;
        });
}
